module.exports = __webpack_public_path__ + "static/media/grillme_quiz.c53c519b.png";